<template>
    <div class="m-content">
        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            Exports
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">

                <div class="row">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-7">
                        <div class="kt-callout__action">
                            <button type="button" v-on:click="exportPatents()" class="btn btn-custom btn-bold btn-upper btn-font-sm  btn-success btn--icon">Export patents</button>
                        </div>
                    </div>
                    <div class="col-lg-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { firestoreDB } from '../../assets/js/firebase';
import exportPatent from '../../assets/js/exportPatent';

export default {
  name: 'ManageExports',
  data() {
    return {
      patents: [],
    };
  },
  mixins: [exportPatent],
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      cruds: (state) => state.crudData.cruds,
    }),
    ...mapGetters([
      'getResourceValue',
      'getResourceValueFirestore',
    ]),
  },
  methods: {
    async exportPatents() {
      console.log('exportPatents', `${process.env.ENV_SHORTNAME}_products_patents`);

      firestoreDB
        .collectionGroup('patents')
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs) {
            this.patents = querySnapshot.docs.map((doc) => {
              const data = doc.data();
              const dataSimplified = {
                productId: doc.ref.parent.parent.id,
                number: this.getResourceValue(data.patent_id, 'patent_id', 'patents', 'number'),
                name: this.getResourceValue(data.patent_id, 'patent_id', 'patents', 'name'),
                roles: data.roles.map((role) => this.getResourceValue(role.role_id, 'role_id', 'roles', 'name')),
                ingredients: data.ingredients.map((ingredient) => this.getResourceValue(ingredient.ingredient_id, 'ingredient_id', 'ingredients', 'name')),
                relatedIncis: data.ingredients.map((ingredient) => this.getResourceValueFirestore(ingredient.related_inci, 'related_inci', 'name')),
              };

              return dataSimplified;
            });
            this.export(this.patents);
          }
        })
        .catch((error) => {
          console.error('Error : ', error);
        });
    },
  },
};
</script>

<style scoped>
    a:hover {
        text-decoration:none;
    }
    .kt-callout {
        padding: 1.5rem; }
    .kt-callout .kt-callout__body {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center; }
    .kt-callout .kt-callout__body .kt-callout__content {
        -webkit-box-flex: 2;
        -ms-flex: 2;
        flex: 2; }
    .kt-callout .kt-callout__body .kt-callout__content .kt-callout__title {
        font-size: 1.85rem;
        font-weight: 500;
        color: #48465b;
        margin-bottom: 1rem; }
    .kt-callout .kt-callout__body .kt-callout__content .kt-callout__desc {
        font-size: 1.15rem;
        line-height: 2rem;
        color: #9392a0;
        padding-right: 2rem;
        font-weight: 400; }
    .kt-callout .kt-callout__body .kt-callout__content .kt-callout__desc:last-child {
        margin-bottom: 0; }
    .kt-callout .kt-callout__body .kt-callout__action {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: end;
        -ms-flex-align: end;
        align-items: flex-end;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center; }
    .kt-callout .kt-callout__body .kt-callout__action .btn.btn-custom {
        padding: 1rem 1.3rem;
        font-size: 0.9rem; }
    .kt-callout--diagonal-bg {
        overflow: hidden;
        position: relative;
        background-color: #fff; }
    .kt-callout--diagonal-bg .kt-callout__body {
        position: relative;
        z-index: 2; }
    .kt-callout--diagonal-bg:before {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #f7f8fa;
        z-index: 1; }
    .kt-callout--diagonal-bg:after {
        content: ' ';
        width: 100%;
        height: 1500px;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 45%;
        -webkit-transform: rotate(20deg);
        transform: rotate(20deg);
        background-color: #fff; }
    .kt-callout--success {
        background-color: rgba(29, 201, 183, 0.07); }
    .kt-callout--success.kt-callout--diagonal-bg {
        background-color: #fff; }
    .kt-callout--success.kt-callout--diagonal-bg:before {
        background-color: rgba(29, 201, 183, 0.15); }
</style>



// WEBPACK FOOTER //
// src/components/Admin/ManageExports.vue